import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.doCallback}},[_vm._l((_vm.parents),function(item){return _c(VIcon,{key:item,attrs:{"color":"transparent"}},[_vm._v("person")])}),(_vm.expanded && _vm.hasChildren)?_c(VIcon,[_vm._v("expand_more")]):_vm._e(),(!_vm.expanded && _vm.hasChildren)?_c(VIcon,[_vm._v("chevron_right")]):_vm._e(),(!_vm.hasChildren)?_c(VIcon,{attrs:{"color":"transparent"}},[_vm._v("person")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }